import './Menu.css';
import {Nav} from 'react-bootstrap';
import {Link, useNavigate} from 'react-router-dom';
import {IoLogOutOutline} from "react-icons/io5"
import { authService } from '../../services/AuthService';

const MenuLogoutButton = ({ isOpen, isMobile}) => {

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await authService.logout();
            navigate('/');
        } catch (error) {
            console.error('Error during logout:', error);
            // Aún navegar a login aunque haya error
            navigate('/');
        }
    }

  return (
      <div className={`${isMobile ? 'logoutMobile logout-section' : 'menu-item-container logout-section'}`}>
          <Nav.Link as={Link} to="/" onClick={handleLogout}>
              <div>
                  <IoLogOutOutline className="icon"/>
              </div>
              <div className='span-container'>
                  <span className={isOpen ? "text" : "text hidden"}>Logout</span>
              </div>
          </Nav.Link>
      </div>
  )
}

export default MenuLogoutButton;